export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(value);
};

export const parseCurrency = (value: string): number | null => {
  if (!value) return null;
  const numberString = value.replace(/[^0-9]/g, '');
  if (numberString === '') return null;
  return parseInt(numberString, 10);
};


export const formatCommissionRate = (rate: number): string => {
  return new Intl.NumberFormat('es-CO', { style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 2 }).format(rate);
};

export const normalizeStringForSearch = (str: string): string => {
    if (!str) return '';
    return str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // Remove accents
        .toLowerCase();
};

export const splitPropertyCodes = (input: string): string[] => {
  if (!input) return [];
  // Split by comma or any whitespace (space, tab, newline)
  return input.split(/[\s,]+/).map(c => c.trim()).filter(Boolean);
};

export const cleanPhoneNumber = (phone: string): string => {
  if (!phone) return '';
  // Remove spaces, parentheses, dots, symbols like plus/minus
  let cleaned = phone.replace(/[\s\(\)\.\+\-]/g, '');
  // If it starts with 57 (from +57 or 57), remove 57 so that only the main number remains
  if (cleaned.startsWith('57')) {
    cleaned = cleaned.substring(2);
  }
  return cleaned;
};
